


























































































































































































































































import Vue, { PropType } from 'vue';
import { JobProgress, Photos, MaintenanceList, HomeCareVideos, CorporateContent, Milestones, BuyerPhoto, AreaImage } from '@/types';
import { getPostCloseData, getMyPhotos, getSelectedPhase, getMockPhase } from '@/api';
import { JobStatus, MilestoneStatus, Phases, Routes } from '@/constants';
import { checkImageUrl, getPhaseCompletionStatus, getPhaseIcon, getRememberMe, hideLoader, isMobile, showLoader } from '@/util';
import { appendCharacter, getAreaCode, getMileStoneToggleStyle, jobOwnershipStatus, mostRecentMilestone } from '../services/service';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'MainContent',
  components: {
    Slider: () => import('@/components/image-slider/ImageCarousel.vue'),
    ContentManagement: () => import('./cms-components/ConstructionStageContent.vue'),
    CheckList: () => import('./cms-components/MaintainenceChecklist.vue')
  },
  data () {
    return {
      selectedIndex: 0,
      toggleFields: {
        plan: false,
        design: false,
        finance: false,
        build: false,
        own: false
      },
      staticPhase: {
        plan: {} as CorporateContent,
        finance: {} as CorporateContent,
        design: {} as CorporateContent
      },
      selectedStep: {} as Milestones,
      scrollValue: 60,
      activeField: '',
      isMobileActive: {} as any,
      pictures: [] as string[],
      foundation: false,
      photos: false,
      surverySteps: [
        'midpoint-survey',
        '30-day-survey',
        '12-month-survey'
      ],
      // sliderMovement: {
      //   enable: true,
      //   mouseHover: true,
      //   timestamp: 5000
      // } as Slide,
      checklist: {} as MaintenanceList,
      homeCareVideos: [] as HomeCareVideos[],
      CMSContent: {} as CorporateContent,
      collapsed: false,
      initial: false
    };
  },
  props: {
    phaseProgress: {
      type: Object as PropType<JobProgress>
    },
    areaId: {
      type: String,
      required: true,
      default: ''
    }
  },
  filters: {
    appendFullStop (data: string) {
      return appendCharacter(data);
    }
  },
  watch: {
    activeField (newValue: string) {
      const step = newValue.toLowerCase();
      if (![Phases.Design.toLowerCase(), Phases.Plan.toLowerCase(), Phases.Finance.toLowerCase()].includes(step)) {
        this.CMSContent = {} as CorporateContent;
        this.selectedStep = {} as Milestones;
      }
    },
    phaseProgress () {
      const recentPhase = this.phaseProgress.mileStones && mostRecentMilestone(this.phaseProgress);
      if (this.postClose) {
        this.fetchPostCloseData();
      }
      recentPhase.toLowerCase() === Phases.Design.toLowerCase() && this.fetchPhotos();
      this.getStaticData(recentPhase);
      if (!isMobile()) {
        this.activeField = recentPhase;
        (this.toggleFields as any)[this.activeField.toLowerCase().trim()] = true;
      } else {
        (this.isMobileActive as any)[recentPhase.toLowerCase().trim()] = true;
      }
      if (this.phaseProgress.currentStatus && this.phaseProgress.currentStatus.phase !== 'own') {
        this.fetchPreCloseData();
      }
      if (this.initial && this.phaseProgress?.mileStones?.Own) {
        this.collapsed = this.checkOwnStageCompleteStatus();
      }
    },
    postClose (value) {
      if (value) {
        this.fetchPostCloseData();
      }
    },
    pictures () {
      if (this.pictures.length > 5) {
        this.pictures = this.pictures.slice(0, 5);
      }
    }
  },
  mounted () {
    this.initial = true;
    this.fetchPhotos();
  },
  computed: {
    ...mapGetters(['user']),
    preClose (): boolean {
      return [JobStatus.PRE_CLOSE].includes(jobOwnershipStatus());
    },
    postClose (): boolean {
      return [JobStatus.POST_CLOSE].includes(jobOwnershipStatus());
    },
    MilestoneStatus () {
      return MilestoneStatus;
    },
    cmsDataExist (): boolean {
      return !!this.activeField && !!(Object.keys(this.CMSContent).length) &&
        (!!this.CMSContent.descriptionText || (this.CMSContent.images && !!this.CMSContent.images[0]));
    },
    showPhotos (): boolean {
      if (this.activeField && this.activeField.toLowerCase() !== 'own') {
        return true;
      } else if (this.activeField.toLowerCase() === '' && this.phaseProgress.status && this.phaseProgress.status !== 'post-close') {
        return true;
      }
      return false;
    },
    showMaintenanceList (): boolean {
      return !!(this.checklist && this.checklist.listItem && this.checklist.listItem.length);
    },
    isSingleHomeCareVideo (): boolean {
      return (this.homeCareVideos?.length < 2);
    }
  },
  methods: {
    checkOwnStageCompleteStatus () {
      this.initial = false;
      if (this.phaseProgress?.mileStones?.Own?.status?.stage.toLowerCase() === 'completed') {
        return true;
      }
      return false;
    },
    closeContentManagement () {
      this.CMSContent = {} as CorporateContent;
      this.selectedStep = {} as Milestones;
    },
    moveMyPhotos () {
      this.$router.push({ name: Routes.PHOTOS })
    },
    updateSelectPagination (pos: number) {
      this.selectedIndex = pos;
    },
    isStaticPhaseStatus (value: string): boolean {
      return this.surverySteps.some(x => value.trim().replace(/\s/g, '-').toLowerCase() === x);
    },
    async stepDetail (step: Milestones, idx: number) {
      const clickedPhase = this.activeField.toLowerCase();
      this.CMSContent = {} as CorporateContent;
      if (this.selectedStep.name !== step.name || this.selectedIndex !== idx) {
        this.selectedIndex = idx;
        this.selectedStep = step;
        if ((clickedPhase === Phases.Build.toLowerCase() || clickedPhase === Phases.Own.toLowerCase()) && !step.isAppointment) {
          const area = getAreaCode(this.user);
          showLoader();
          getSelectedPhase(area, step.keyName).then(response => {
            this.CMSContent = (response || {}) as CorporateContent;
            this.CMSContent.descriptionText = unescape(this.CMSContent.descriptionText);
            hideLoader();
          })
        }
      } else {
        this.closeContentManagement();
      }
    },
    async getStaticData (clickedPhase: string) {
      type phase = 'plan' | 'finance' | 'design';
      const step = clickedPhase.toLowerCase();
      if ([Phases.Design.toLowerCase(), Phases.Plan.toLowerCase(), Phases.Finance.toLowerCase()].includes(step)) {
        showLoader();
        if (!this.staticPhase[clickedPhase.toLowerCase() as phase].descriptionText) {
          const response = await getMockPhase();
          this.staticPhase.plan = response.plan;
          this.staticPhase.finance = response.finance;
          const designPhase = Object.assign({}, {
            descriptionText: response.design.descriptionText,
            images: response.design.defaultImage
          } as CorporateContent);
          response.design.areas.forEach((area: AreaImage) => {
            if (area.code.toLowerCase() === this.areaId.toLowerCase()) {
              designPhase.images = [area.image];
            }
          });
          this.staticPhase.design = designPhase;
        }
        this.CMSContent = this.staticPhase[clickedPhase.toLowerCase() as phase] as CorporateContent;
        this.selectedStep = {
          name: clickedPhase,
          status: this.getStageStatus(clickedPhase as 'Design' | 'Plan' | 'Finance')
        } as Milestones;
        hideLoader();
      }
    },
    getStatus (value?: string) {
      return getPhaseCompletionStatus(value);
    },
    getIcon (phase: string) {
      return getPhaseIcon(phase);
    },
    toTitleCase (data: string) {
      return data.replace(/\w+/g, (word) => word[0].toUpperCase() + word.slice(1).toLowerCase());
    },
    getToggleStyle (value: string): string {
      return getMileStoneToggleStyle(value);
    },
    setMilestoneScroll () {
      const idElement = document.querySelector('#mileStoneDiv');
      if (idElement != null) {
        idElement.scrollLeft = this.scrollValue;
      }
    },
    showActive (value: string) {
      const el = document.querySelector('#progress');
      el && el.classList.contains('mobScroll') && el.classList.remove('mobScroll');
      if (Object.keys(this.isMobileActive).length) {
        this.isMobileActive = {};
      }
      this.handlePhaseClick(value, el).then(res => {
        this.scrollValue = (this.toggleFields as any)[value.toLowerCase().trim()] ? 60 : 0;
        this.setMilestoneScroll();
      })
    },
    async handlePhaseClick (value: string, el: Element | null) {
      if (value === this.activeField) {
        this.activeField = '';
      } else {
        if (this.activeField !== '') {
          (this.toggleFields as any)[this.activeField.toLowerCase().trim()] = false;
        }
        this.setActiveField(value, el);
        await this.getStaticData(this.activeField);
        // value.toLowerCase() === 'design' && !this.photos && await this.fetchPhotos();
      }
      (this.toggleFields as any)[value.toLowerCase().trim()] = !(this.toggleFields as any)[value.toLowerCase().trim()];
    },
    setActiveField (value: string, el: Element | null) {
      this.activeField = value;
      el && el.classList.add('mobScroll');
    },
    async fetchPhotos () {
      this.photos = true;
      const jobId = getRememberMe() || '';
      const buyerPhoto: BuyerPhoto = await getMyPhotos(jobId, 10);
      if (buyerPhoto && buyerPhoto.photos) {
        let correctImagesUrl = await checkImageUrl(buyerPhoto.photos);
        correctImagesUrl = correctImagesUrl.sort((picture1, picture2) => {
          if (picture2.createdDate && picture1.createdDate) {
            return this.compare(picture2.createdDate, picture1.createdDate)
          }
          return 0;
        });
        this.pictures = correctImagesUrl.map((pics: Photos) => {
          return pics.assetValue;
        });
      }
    },
    compare (first: string, secound: string) {
      if (first < secound) {
        return -1;
      }
      if (first > secound) {
        return 1;
      }
      return 0;
    },
    fetchPostCloseData () {
      const jobId = getRememberMe() || '';
      let recentPhase = this.phaseProgress.mileStones && mostRecentMilestone(this.phaseProgress);
      if (!recentPhase) {
        recentPhase = 'own';
      }
      getPostCloseData(jobId, recentPhase).then(response => {
        if (response) {
          this.homeCareVideos = response.HomeCareVideo;
          this.sortHomeCareVideos();
          this.checklist = response.HomeMaintenanceChecklist;
        }
      });
    },
    fetchPreCloseData () {
      const jobId = getRememberMe() || '';
      if (this.phaseProgress.currentStatus && this.phaseProgress.currentStatus.phase.toLowerCase() !== Phases.Own.toLowerCase()) {
        getPostCloseData(jobId, this.phaseProgress.currentStatus.phase).then(response => {
          if (response) {
            this.homeCareVideos = response.HomeCareVideo;
            this.sortHomeCareVideos();
            this.checklist = response.HomeMaintenanceChecklist;
          }
        });
      }
    },
    isPurchaseAgreementStep (phase: string, cureentStep: string): boolean {
      return phase.toLowerCase().trim().includes('plan') && cureentStep.toLowerCase().trim().includes('purchase agreement');
    },
    getStageStatus (phase: 'Design' | 'Plan' | 'Finance') {
      return this.phaseProgress.mileStones[phase].status;
    },
    sortMilestoneAppointments (steps: Milestones[]) {
      let allAppointments = steps.filter((step) => step.isAppointment);
      const allMilestones = steps.filter((step) => !step.isAppointment);
      allAppointments = allAppointments.sort((appt1, appt2) => {
        const fa = appt1.date || '';
        const fb = appt2.date || '';
        return (fa > fb) ? 1 : (fb > fa) ? -1 : 0;
      });
      const unscheduledAppts = allAppointments.filter((appt) => !appt.date);
      const scheduledAppts = allAppointments.filter(appt => appt.date);
      allAppointments = scheduledAppts.concat(unscheduledAppts);
      return allMilestones.concat(allAppointments);
    },
    toggleCardVisibility () {
      this.collapsed = !this.collapsed;
    },
    sortHomeCareVideos () {
      this.homeCareVideos.sort((video1, video2) => {
        if (video1.videoTitle === video2.videoTitle && video1.stage === video2.stage && video1.startDate === video2.startDate) {
          if (video1.area === 'corporate') return 1;
          if (video2.area === 'corporate') return -1;
        }
        return 0;
      })
    }
  }
});
